<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6 rounded-lg">
      <v-card-title class="pl-7 pr-7 pt-7"> DocuSign účet </v-card-title>
      <v-card-text class="pa-7">
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Plán</div>
                <div class="request-value mt-2">
                  {{ account.planName }}
                </div>
              </v-col>
            </v-row>
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Počet podpisů</div>
                <div class="request-value mt-2">
                  {{ account.billingPeriodEnvelopesAllowed }}
                </div>
              </v-col>
            </v-row>
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Počet provedených podpisů</div>
                <div class="request-value mt-2">
                  {{ account.billingPeriodEnvelopesSent }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SettingDetail',
  data() {
    return {
      account: null,
      accountLoading: false,
    }
  },
  async created() {
    this.loadAccount()
  },
  methods: {
    ...mapActions({
      getDocusignAccountInfo: 'setting/getDocusignAccountInfo',
    }),
    loadAccount() {
      this.accountLoading = true
      this.getDocusignAccountInfo()
        .then((response) => {
          this.account = response.data
        })
        .finally(() => {
          this.accountLoading = false
        })
    },
  },
}
</script>
